(function () {
  if (window.__abHeroStepInitialized) return;
  window.__abHeroStepInitialized = true;

  function bindScrollButton() {
    document.addEventListener("click", function (event) {
      var btn = event.target.closest(".ab-hero-step__bottom-cta");
      if (!btn) return;

      var selector = (btn.getAttribute("data-scroll-target") || "").trim();
      var target = document.getElementById("aqua-bot-offer") || document.getElementById("product-offer");

      if (!target && selector) {
        try {
          target = document.querySelector(selector);
        } catch (error) {
          target = null;
        }
      }

      if (!target) {
        target = document.getElementById("MainContent") || document.body;
      }

      var top = target.getBoundingClientRect().top + window.pageYOffset - 12;

      window.scrollTo({
        top: Math.max(top, 0),
        behavior: "smooth"
      });
    });
  }

  function initLazyVideos(root) {
    var scope = root || document;
    var videos = scope.querySelectorAll(".ab-hero-step__video[autoplay]");

    if (!videos.length) return;

    if (!("IntersectionObserver" in window)) {
      videos.forEach(function (video) {
        video.setAttribute("preload", "metadata");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            video.setAttribute("preload", "metadata");
            var playPromise = video.play();

            if (playPromise && typeof playPromise.catch === "function") {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      },
      {
        root: null,
        rootMargin: "50px 0px",
        threshold: 0.15
      }
    );

    videos.forEach(function (video) {
      if (video.hasAttribute("data-ab-observed")) return;

      video.setAttribute("data-ab-observed", "true");
      observer.observe(video);
    });
  }

  function bindVideoPlayButtons() {
    /* pd-video-play-single-active-v1 */
    var deactivateActiveVideo = null;

    document.addEventListener("click", function (event) {
      if (!(event.target instanceof Element)) return;

      var button = event.target.closest(".ab-hero-step__video-play");
      if (!button || button.getAttribute("aria-busy") === "true") return;

      var mediaBox = button.closest(".ab-hero-step__media-box");
      var video = mediaBox && mediaBox.querySelector(".ab-hero-step__video");
      if (!video) return;

      if (deactivateActiveVideo) {
        deactivateActiveVideo();
      }

      var originalLabel = button.getAttribute("aria-label") || "Play video";
      var settled = false;
      var timeoutId;

      function cleanup() {
        window.clearTimeout(timeoutId);
        video.removeEventListener("playing", finishPlayback);
        video.removeEventListener("error", restoreButton);
      }

      function deactivate() {
        cleanup();
        settled = true;
        video.pause();
        video.controls = false;
        button.hidden = false;
        button.removeAttribute("aria-busy");
        button.setAttribute("aria-label", originalLabel);

        if (deactivateActiveVideo === deactivate) {
          deactivateActiveVideo = null;
        }
      }

      function restoreButton() {
        if (settled) return;
        deactivate();
      }

      function finishPlayback() {
        if (settled) return;
        settled = true;
        cleanup();
        video.controls = true;
        button.hidden = true;
        button.removeAttribute("aria-busy");
        button.setAttribute("aria-label", originalLabel);
      }

      deactivateActiveVideo = deactivate;
      button.hidden = false;
      button.setAttribute("aria-busy", "true");
      button.setAttribute("aria-label", "Loading video");
      video.controls = false;
      video.setAttribute("preload", "auto");
      video.addEventListener("playing", finishPlayback, { once: true });
      video.addEventListener("error", restoreButton, { once: true });
      timeoutId = window.setTimeout(restoreButton, 10000);
      video.load();

      try {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(restoreButton);
        }
      } catch (error) {
        restoreButton();
      }
    });
  }

  function bindDeferredInternalVideoButtons() {
    document.addEventListener(
      "click",
      function (event) {
        if (!(event.target instanceof Element)) return;

        var button = event.target.closest("internal-video .internal-video__play");
        if (!button) return;

        var root = button.closest("internal-video");
        var video = root && root.querySelector("video");
        if (!video) return;

        video.querySelectorAll("source[data-src]").forEach(function (source) {
          if (!source.getAttribute("src")) {
            source.setAttribute("src", source.getAttribute("data-src"));
          }
        });

        video.setAttribute("preload", "auto");
        video.load();
      },
      true
    );
  }

  function init(root) {
    initLazyVideos(root || document);
  }

  bindScrollButton();
  bindVideoPlayButtons();
  bindDeferredInternalVideoButtons();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
